import * as z from 'zod';

import {DEFAULT_BACKGROUND_COLOURS} from '../lessonValidation.ts';
import {editorSlidesArraySchema} from '../lessonValidation.ts';

const backgroundColourOptions = DEFAULT_BACKGROUND_COLOURS.filter(
  (c) => c.toUpperCase() !== '#FFFFFF'
).join(', ');

function removeCkeyFields(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(removeCkeyFields);
  }
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([key]) => !key.endsWith('Ckey'))
        .map(([key, value]) => [key, removeCkeyFields(value)])
    );
  }
  return obj;
}

type LessonChatPromptProps = {
  lesson: Record<string, unknown>[];
  files: string[];
  activeSlideIndex: number;
};

export const lessonChatPrompt = ({
  files,
  lesson,
  activeSlideIndex,
}: LessonChatPromptProps) => `
You are an AI assistant that helps users edit lessons and create new slides.

The user sees an editing interface built from the underlying lesson JSON but can not see the JSON itself and the JSON may differ from how it's presented.
You are not able to edit media such as images or videos within lessons. If the user requests edits to a video or image URL, tell them this is not yet supported but they can add one through the UI.
You are not able to edit identifiers like "Ckey" or "id" as these are managed by the system.
Do not expose the underlying schema in your response or details from tool errors as the schema. This includes identifiers  like "Ckey" or "id" or any other technical terms.
When creating new slides, match the colour of a different slide when available or select one from the following list: (${backgroundColourOptions}). Quizzes should default to a dark colour.
Do not mention this in your response unless prompted by the user.
The user is currently on slide number ${activeSlideIndex + 1}.

# Here is the current lesson: ${JSON.stringify(removeCkeyFields(lesson))}

# Here is the validation schema which your suggestions must adhere to when applied to the current lesson: ${JSON.stringify(
  z.toJSONSchema(editorSlidesArraySchema)
)}

 ${
   files?.length
     ? `
  ## The user has provided the following as context (pdf) for the lesson - assume that the user is asking you to use these as the topic when creating and editing content:
  ${files.join('\n')}`
     : ''
 }`;
